import { useLocation, useNavigate } from 'react-router-dom'
import questionMarkIcon from './images/question-mark-icon.svg'
import filterIcon from './images/filter-icon-mobile.svg'
import tableIcon from './images/table-icon-mobile.svg'
import mapIcon from './images/map-icon-active-mobile.svg'
import { Switch, SwitchProps, styled } from '@mui/material'
import { RoutePath } from '../../constants'

const CustomSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 76,
  height: 42,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 7,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      paddingLeft: 16,
      '& + .MuiSwitch-track': {
        backgroundColor: '#ffffff',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#222222',
      border: '6px solid #222222',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: '#222222',
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 28,
    height: 28,
    color: '#e9e7e1',
  },
  '& .MuiSwitch-track': {
    borderRadius: 21,
    backgroundColor: '#222222',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    border: `1px solid #e9e7e1`,
    width: '100%',
  },
}))

type MapToggleMobileProps = {
  onToggleFilterModalVisibility: () => void
  onExplainerStepChange: (step: number) => void
  filterSectionRef: React.RefObject<HTMLDivElement>
}

function MapToggleMobile({
  onToggleFilterModalVisibility,
  onExplainerStepChange,
  filterSectionRef,
}: MapToggleMobileProps) {
  const { pathname: viewType } = useLocation()
  const navigate = useNavigate()

  return (
    <div className="fixed bottom-0 left-0 h-[80px] flex items-center justify-center border-t-[1px] border-white w-full bg-[#222222]">
      <div
        className="border-r-[1px] border-white flex p-4 justify-center items-center h-full"
        role="button"
        onClick={onToggleFilterModalVisibility}
        ref={filterSectionRef}
      >
        <img
          src={filterIcon}
          alt="Filter representation"
          className="w-[34px] h-[29px]"
        />
      </div>
      <div className="py-4 px-8 items-center justify-center flex gap-8 flex-1">
        <img src={mapIcon} alt="Folded map" />
        <CustomSwitch
          checked={viewType === RoutePath.Table}
          onChange={() => {
            if (viewType === RoutePath.Map) {
              if (typeof window.gtag === 'function') {
                window.gtag('event', 'view_toggle', { view: 'table' })
              }
              navigate(RoutePath.Table)
            } else {
              if (typeof window.gtag === 'function') {
                window.gtag('event', 'view_toggle', { view: 'map' })
              }
              navigate(RoutePath.Map)
            }
          }}
          inputProps={{ 'aria-label': 'mobile toggle between map and table' }}
        />
        <img src={tableIcon} alt="Excel sheet" />
      </div>
      <div className="border-l-[1px] border-white flex p-4 justify-center items-center h-full">
        <img
          src={questionMarkIcon}
          alt="Question mark"
          role="button"
          className="w-[42px] h-[42px]"
          onClick={() => {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth',
            })
            onExplainerStepChange(1)
          }}
        />
      </div>
    </div>
  )
}

export default MapToggleMobile
